import { PROFILE_ROUTES } from './routesByGroups/profile';
import { DASHBOARD_ROUTES } from './routesByGroups/dashboard';
import { ALERT_ROUTES } from './routesByGroups/alert';
import { ACCOUNT_ROUTES } from './routesByGroups/account';
import { USER_ROUTES } from './routesByGroups/user';
import { PATIENT_ROUTES } from './routesByGroups/patient';
import { ORDER_ROUTES } from './routesByGroups/order';
import { ASSESSMENT_ROUTES } from './routesByGroups/assessment';
import { RESOURCE_ROUTES } from './routesByGroups/resource';
import { CLAIM_ROUTES } from './routesByGroups/claim';
import { CLAIM_REPORT_ROUTES } from './routesByGroups/claimReport';
import { REPORTABLE_ROUTES } from './routesByGroups/reportable';
import { BOT_ACTIVITY_ROUTES } from './routesByGroups/botActivity';
import { PROGRAM_ROUTES } from './routesByGroups/program';
import { ALLERGI_END_RESOURCES_ROUTES } from './routesByGroups/allergiEndResources';
// import { INSTANT_ASSESSMENT_ROUTES } from './routesByGroups/instantAssessment';

export const PRIVATE_ROUTES = {
  profile: PROFILE_ROUTES,
  dashboard: DASHBOARD_ROUTES,
  alert: ALERT_ROUTES,
  account: ACCOUNT_ROUTES,
  user: USER_ROUTES,
  patient: PATIENT_ROUTES,
  order: ORDER_ROUTES,
  assessment: ASSESSMENT_ROUTES,
  resource: RESOURCE_ROUTES,
  claim: CLAIM_ROUTES,
  claimReport: CLAIM_REPORT_ROUTES,
  reportable: REPORTABLE_ROUTES,
  botActivity: BOT_ACTIVITY_ROUTES,
  program: PROGRAM_ROUTES,
  allergiEndResources: ALLERGI_END_RESOURCES_ROUTES,
  // instantAssessment: INSTANT_ASSESSMENT_ROUTES,
};

